"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ApiEnvironments: ()=>ApiEnvironments,
    ApiEnvironmentsList: ()=>ApiEnvironmentsList,
    getEnvironment: ()=>getEnvironment,
    changeApiUrl: ()=>changeApiUrl,
    authHeaders: ()=>authHeaders,
    api: ()=>api,
    rememberMeApi: ()=>rememberMeApi
});
const _cryptoJs = require("crypto-js");
const _ = require("..");
const _reactNative = require("react-native");
var ApiEnvironments;
(function(ApiEnvironments) {
    ApiEnvironments[ApiEnvironments['alpha'] = 0] = 'alpha';
    ApiEnvironments[ApiEnvironments['beta'] = 1] = 'beta';
    ApiEnvironments[ApiEnvironments['staging'] = 2] = 'staging';
    ApiEnvironments[ApiEnvironments['delta'] = 3] = 'delta';
    ApiEnvironments[ApiEnvironments['epsilon'] = 4] = 'epsilon';
    ApiEnvironments[ApiEnvironments['gamma'] = 5] = 'gamma';
    ApiEnvironments[ApiEnvironments['zeta'] = 6] = 'zeta';
    ApiEnvironments[ApiEnvironments['production'] = 7] = 'production';
    ApiEnvironments[ApiEnvironments['localhost'] = 8] = 'localhost';
})(ApiEnvironments || (ApiEnvironments = {}));
const ApiEnvironmentsList = Object.values(ApiEnvironments).filter((t)=>/[^\d]/.test(t));
const makeApiUrl = (env)=>{
    const _env = env || getEnvironment();
    if (_env === 'localhost') {
        return 'http://localhost:3000/api';
    }
    return `https://${_env}.api.mywallet.deals`;
};
const makeRememberMeApiUrl = (env)=>{
    let _env = env || getEnvironment();
    if (_env === 'localhost') {
        return 'http://localhost:3000/api';
    }
    if (_env === 'production') {
        _env = "";
    } else {
        _env = _env ? _env + "." : "";
    }
    if (window && window.location && window.location.hostname) {
        if (process.env.NODE_ENV === 'development') {
            return `https://api.${_env}springbig-wallet-3.click`;
        }
        const processedFromLambdaProxy = document?.querySelector('meta[name="processed-from-lambda-proxy"]')?.getAttribute('content');
        if (processedFromLambdaProxy === 'true') {
            return `https://api.${location.host}`;
        }
        return `https://api.${_env}${location.host}`;
    }
    if (!env) {
        _env = __DEV__ ? 'beta' : 'production';
    } else {
        _env = env;
    }
    return `https://${_env}.api.mywallet.deals`;
};
const getEnvironment = ()=>{
    let _env;
    if (_reactNative.Platform.OS === 'web') {
        let locallyStoredEnv = window && window.location && localStorage && localStorage.getItem('app:apiEnv');
        if (locallyStoredEnv) {
            _env = locallyStoredEnv.replaceAll("\"", "");
        }
    }
    if (!_env) {
        _env = __DEV__ ? "beta" : "production";
    }
    return _env;
};
const changeApiUrl = (env)=>{
    api.changeBaseUrl(makeApiUrl(env));
    api.setStore({
        apiEnv: env
    });
    rememberMeApi.changeBaseUrl(makeRememberMeApiUrl(env));
    rememberMeApi.setStore({
        apiEnv: env
    });
};
const authHeaders = (phoneNumber, userToken)=>{
    const time = Math.ceil(+new Date() / 1000);
    const hashText = `${phoneNumber}_${time}`;
    const hmac = (0, _cryptoJs.HmacSHA256)(hashText, `${userToken}`).toString();
    return {
        hmac,
        time
    };
};
const api = new _.ApiFactory({
    // required
    baseUrl: makeApiUrl(),
    type: 'json',
    // optional
    headers: {
        'content-type': 'application/json'
    },
    makeOptions (opts, store) {
        if (store.phoneNumber && store.mobileSubscriberId) {
            const { hmac , time  } = authHeaders(store.phoneNumber, store.mobileSubscriberId);
            opts.headers = {
                ...opts.headers || {},
                'hmac-timestamp': `${time}`,
                'hmac-signature': hmac
            };
        }
        return opts;
    }
});
const rememberMeApi = new _.ApiFactory({
    // required
    baseUrl: makeRememberMeApiUrl(),
    type: 'json',
    // optional
    headers: {
        'content-type': 'application/json'
    },
    makeOptions (opts, store) {
        if (store.phoneNumber && store.mobileSubscriberId) {
            const { hmac , time  } = authHeaders(store.phoneNumber, store.mobileSubscriberId);
            opts.headers = {
                ...opts.headers || {},
                'hmac-timestamp': `${time}`,
                'hmac-signature': hmac
            };
        }
        return opts;
    }
});
_.observer.on('switch-env', ({ env  })=>{
    changeApiUrl(env);
    _.observer.emit('env-changed');
});
_.observer.on('storage-set', ({ key , value  })=>{
    if (key === 'apiEnv') {
        _.observer.emit('switch-env', {
            env: value
        });
    }
});
